export const theme = {
  bg:          '#000000',
  surface1:    '#0D0D0D',
  surface2:    '#161616',
  surface3:    '#1F1F1F',
  border:      '#242424',
  borderLight: '#303030',
  text:        '#FFFFFF',
  text2:       '#888888',
  text3:       '#666666',
  accent:      '#FFFFFF',
  accentLight: '#E8E8E8',
  green:       '#3DBA6F',
  red:         '#EF4444',
} as const;

// Linear gradient color pairs for character cards [from, to]
// All cards share the same dark gradient for a unified look
const CARD: readonly [string, string] = ['#111111', '#1e1e1e'];

export const cardBg: Record<string, readonly [string, string]> = {
  freud:        CARD,
  anime:        CARD,
  arya:         CARD,
  einstein:     CARD,
  miku:         CARD,
  stranger:     CARD,
  cleopatra:    CARD,
  sherlock:     CARD,
  shelby:       CARD,
  deadpool:     CARD,
  stark:        CARD,
  hannibal:     CARD,
  bateman:      CARD,
  napoleon:     CARD,
  caesar:       CARD,
  alexander:    CARD,
  genghis:      CARD,
  vinci:        CARD,
  michel:       CARD,
  shakespeare:  CARD,
  darwin:       CARD,
  newton:       CARD,
  tesla:        CARD,
  churchill:    CARD,
  lincoln:      CARD,
  socrates:     CARD,
  aristotle:    CARD,
  plato:        CARD,
  confucius:    CARD,
  columbus:     CARD,
  mozart:       CARD,
  beethoven:    CARD,
  andersen:     CARD,
  poe:          CARD,
  wilde:        CARD,
  nietzsche:    CARD,
  marx:         CARD,
  hawking:      CARD,
  musk:         CARD,
  jobs:         CARD,
  gates:        CARD,
  buffett:      CARD,
  franklin:     CARD,
  roosevelt:    CARD,
  mao:          CARD,
  gandhi:       CARD,
  mandela:      CARD,
  mlk:          CARD,
  aurelius:     CARD,
  diogenes:     CARD,
  peter1:       CARD,
  catherine:    CARD,
  ivan4:        CARD,
  nevsky:       CARD,
  suvorov:      CARD,
  kutuzov:      CARD,
  nicholas2:    CARD,
  gagarin:      CARD,
  pushkin:      CARD,
  dostoevsky:   CARD,
  tolstoy:      CARD,
  vysotsky:     CARD,
  rasputin:     CARD,
  mendeleev:    CARD,
  walter:       CARD,
  tyrion:       CARD,
  joker:        CARD,
  geralt:       CARD,
  kratos:       CARD,
  light:        CARD,
  lchar:        CARD,
  levi:         CARD,
  eren:         CARD,
  goku:         CARD,
  luffy:        CARD,
  ali:          CARD,
  ronaldo:      CARD,
  montana:      CARD,
  corleone:     CARD,
  jones:        CARD,
  wick:         CARD,
  potter:       CARD,
  vader:        CARD,
  gandalf:      CARD,
  itachi:       CARD,
  tanjiro:      CARD,
  zoro:         CARD,
  kakashi:      CARD,
  edward:       CARD,
  arthur:       CARD,
  agent47:      CARD,
  ezio:         CARD,
  masterchief:  CARD,
  jeanne:       CARD,
  attila:       CARD,
  dexter:       CARD,
  house:        CARD,
  sasuke:       CARD,
  deku:         CARD,
  allmight:     CARD,
  rem:          CARD,
  asuka:        CARD,
  tyler:        CARD,
  forrest:      CARD,
  alex:         CARD,
  chigur:       CARD,
  machiavelli:  CARD,
  sunzi:        CARD,
  jung:         CARD,
  adler:        CARD,
  pavlov:       CARD,
  maslow:       CARD,
  rogers:       CARD,
  frankl:       CARD,
  vygotsky:     CARD,
  skinner:      CARD,
  piaget:       CARD,
  fromm:        CARD,
  bradpitt:     CARD,
  dicaprio:     CARD,
  tomcruise:    CARD,
  jolie:        CARD,
  bellucci:     CARD,
  meganfox:     CARD,
  depp:         CARD,
  sweeney:      CARD,
  statham:      CARD,
  anadearmas:   CARD,
  robbie:       CARD,
  gosling:      CARD,
  stephenking:  CARD,
  napoleonhill: CARD,
  berne:        CARD,
  carnegie:     CARD,
  jamesclear:   CARD,
  cialdini:     CARD,
  maxwell:      CARD,
  clason:       CARD,
  larryking:    CARD,
  covey:        CARD,
  tutankhamun:  CARD,
  lara:         CARD,
  sonic:        CARD,
  mario:        CARD,
  ciri:         CARD,
  joel:         CARD,
  donjuan:      CARD,
  dracula:      CARD,
  minato:       CARD,
  rei:          CARD,
  pikachu:      CARD,
  sailor:       CARD,
  cloud:        CARD,
  link:         CARD,
  solidsnake:   CARD,
  freddie:      CARD,
  elvis:        CARD,
  spiderman:    CARD,
  batman:       CARD,
  gatsby:       CARD,
  nefertiti:    CARD,
  buddha:       CARD,
  stalin:       CARD,
  chekhov:      CARD,
  tchaikovsky:  CARD,
  soprano:      CARD,
  jordan:       CARD,
  tyson:        CARD,
  mikasa:       CARD,
  gohan:        CARD,
  guts:         CARD,
  kaneki:       CARD,
  dante:        CARD,
  drake:        CARD,
  aloy:         CARD,
  jackson:      CARD,
  marley:       CARD,
  monroe:       CARD,
  brucelee:     CARD,
  bowie:        CARD,
  ramses:       CARD,
  leonidas:     CARD,
  lenin:        CARD,
  lomonosov:    CARD,
  jesse:        CARD,
  cersei:       CARD,
  federer:      CARD,
  messi:        CARD,
  bulgakov:     CARD,
  esenin:       CARD,
  mayakovsky:   CARD,
  rachmaninov:  CARD,
  sakharov:     CARD,
  solzhenitsyn: CARD,
  turgenev:     CARD,
  gogol:        CARD,
  bunin:        CARD,
};
